import { render, staticRenderFns } from "./EditMinSpendPolicy.vue?vue&type=template&id=5746110c&"
import script from "./EditMinSpendPolicy.vue?vue&type=script&lang=js&"
export * from "./EditMinSpendPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports